import { amazonpayService } from "../amazonpay.service";
import { amazonpayConstants } from "./amazonpay.constants";

export const amazonpayActions = {
    getAllAmazonPayConfigurations,
    addAmazonPayConfiguration,
    updateAmazonPayConfiguration,
    deleteAmazonPayConfiguration,
    toggleEditConfigurationModal,
    toggleDeleteConfigurationModal,
    toggleAmazonPayImportModal,
    uploadAmazonPayDataFile,
    resetState,
    migrateToVersion2,
    loadMigrationModal,
    setConfigurationAndClientToMigrate,
    setTransitAccountsMessage,
    setHoldingAccountsMessage,
    updateValueOnConfiguration,
};

function getAllAmazonPayConfigurations() {
    return (dispatch) => {
        dispatch(request());

        return amazonpayService.getAllAmazonPayConfigurations().then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                if (error.message) {
                    dispatch(failure(error.message));
                } else {
                    dispatch(failure(error));
                }
                return error;
            }
        );
    };

    function request() {
        return { type: amazonpayConstants.GET_AMAZONPAY_CONFIGURATIONS_REQUEST };
    }

    function success(result) {
        return {
            type: amazonpayConstants.GET_AMAZONPAY_CONFIGURATIONS_SUCCESS,
            result,
        };
    }

    function failure(errorMessage) {
        return {
            type: amazonpayConstants.GET_AMAZONPAY_CONFIGURATIONS_FAILURE,
            errorMessage,
        };
    }
}

function addAmazonPayConfiguration(configuration) {
    return (dispatch) => {
        dispatch(request());

        return amazonpayService.addAmazonPayConfiguration(configuration).then(
            (organization) => {
                dispatch(success(organization));
                return organization;
            },
            (error) => {
                if (error.message) {
                    dispatch(failure(error.message));
                } else {
                    dispatch(failure(error));
                }
                return error;
            }
        );
    };

    function request() {
        return { type: amazonpayConstants.ADD_AMAZONPAY_CONFIGURATION_REQUEST };
    }

    function success(result) {
        return {
            type: amazonpayConstants.ADD_AMAZONPAY_CONFIGURATION_SUCCESS,
            result,
        };
    }

    function failure(errorMessage) {
        return {
            type: amazonpayConstants.ADD_AMAZONPAY_CONFIGURATION_FAILURE,
            errorMessage,
        };
    }
}

function updateAmazonPayConfiguration(configuration) {
    return (dispatch) => {
        dispatch(request());

        return amazonpayService.updateAmazonPayConfiguration(configuration).then(
            (configuration) => {
                if (configuration.errorMessage && configuration.errorMessage !== "") {
                    dispatch(failure(configuration.errorMessage));
                } else {
                    dispatch(success(configuration));
                }
                return configuration;
            },
            (error) => {
                if (error.message) {
                    dispatch(failure(error.message));
                } else {
                    dispatch(failure(error));
                }
                return error;
            }
        );
    };

    function request() {
        return { type: amazonpayConstants.UPDATE_AMAZONPAY_CONFIGURATION_REQUEST };
    }

    function success(configuration) {
        return {
            type: amazonpayConstants.UPDATE_AMAZONPAY_CONFIGURATION_SUCCESS,
            configuration,
        };
    }

    function failure(errorMessage) {
        return {
            type: amazonpayConstants.UPDATE_AMAZONPAY_CONFIGURATION_FAILURE,
            errorMessage,
        };
    }
}

function deleteAmazonPayConfiguration(uuid) {
    return (dispatch) => {
        dispatch(request());

        return amazonpayService.deleteAmazonPayConfiguration(uuid).then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                if (error.message) {
                    dispatch(failure(error.message));
                } else {
                    dispatch(failure(error));
                }
                return error;
            }
        );
    };

    function request() {
        return { type: amazonpayConstants.DELETE_AMAZONPAY_CONFIGURATION_REQUEST };
    }

    function success(result) {
        return {
            type: amazonpayConstants.DELETE_AMAZONPAY_CONFIGURATION_SUCCESS,
            result: result,
        };
    }

    function failure(errorMessage) {
        return {
            type: amazonpayConstants.DELETE_AMAZONPAY_CONFIGURATION_FAILURE,
            errorMessage,
        };
    }
}

function toggleEditConfigurationModal() {
    return (dispatch) => {
        dispatch({ type: amazonpayConstants.TOGGLE_EDIT_CONFIGURATION_MODAL });
    };
}

function toggleDeleteConfigurationModal(configuration) {
    return (dispatch) => {
        dispatch({
            type: amazonpayConstants.TOGGLE_DELETE_CONFIGURATION_MODAL,
            configuration: configuration,
        });
    };
}

function toggleAmazonPayImportModal(itemId) {
    return (dispatch) => {
        dispatch({
            type: amazonpayConstants.TOGGLE_AMAZONPAY_IMPORT_MODAL,
            itemId: itemId,
        });
    };
}

function uploadAmazonPayDataFile(file, importId) {
    return (dispatch) => {
        dispatch(request());

        return amazonpayService.uploadAmazonPayDataFile(file, importId).then(
            (result) => {
                if (result.errorMessage) {
                    if (result.response) {
                        dispatch(success(result.response));
                    }
                    dispatch(failure(result.errorMessage));
                } else {
                    dispatch(success(result));
                }
                return result;
            },
            (error) => {
                if (error.message) {
                    dispatch(failure(error.message));
                } else {
                    dispatch(failure(error));
                }
                return error;
            }
        );
    };

    function request() {
        return { type: amazonpayConstants.UPLOAD_AMAZONPAY_DATA_FILE_REQUEST };
    }

    function success(result) {
        return {
            type: amazonpayConstants.UPLOAD_AMAZONPAY_DATA_FILE_SUCCESS,
            result,
        };
    }

    function failure(errorMessage) {
        return {
            type: amazonpayConstants.UPLOAD_AMAZONPAY_DATA_FILE_FAILURE,
            errorMessage,
        };
    }
}

function resetState() {
    return { type: amazonpayConstants.RESET_STATE };
}

function migrateToVersion2(configuration) {
    return (dispatch) => {
        dispatch(request());

        return amazonpayService.migrateToVersion2(configuration).then(
            (result) => {
                if (result.errorMessage) {
                    if (result.response) {
                        dispatch(success(result.response));
                    }
                    dispatch(failure(result.errorMessage));
                } else {
                    dispatch(success(result));
                }
                return result;
            },
            (error) => {
                if (error.message) {
                    dispatch(failure(error.message));
                } else {
                    dispatch(failure(error));
                }
                return error;
            }
        );
    };

    function request() {
        return { type: amazonpayConstants.MIGRATE_CONFIGURATION_TO_V2_REQUEST };
    }

    function success(result) {
        return {
            type: amazonpayConstants.MIGRATE_CONFIGURATION_TO_V2_SUCCESS,
            result,
        };
    }

    function failure(errorMessage) {
        return {
            type: amazonpayConstants.MIGRATE_CONFIGURATION_TO_V2_FAILURE,
            errorMessage,
        };
    }
}

function loadMigrationModal() {
    return (dispatch) => {
        dispatch({
            type: amazonpayConstants.LOAD_AMAZONPAY_MIGRATION_MODAL,
        });
    };
}

function setConfigurationAndClientToMigrate(client, configuration, hasAuthData) {
    return (dispatch) => {
        dispatch({
            type: amazonpayConstants.SET_CONFIGURATION_AND_CLIENT_TO_MIGRATE,
            payload: { client, configuration, hasAuthData },
        });
    };
}

function setTransitAccountsMessage() {
    return (dispatch) => {
        dispatch({
            type: amazonpayConstants.SET_TRANSIT_ACCOUNT_MESSAGE,
        });
    };
}

function setHoldingAccountsMessage() {
    return (dispatch) => {
        dispatch({
            type: amazonpayConstants.SET_HOLDING_ACCOUNT_MESSAGE,
        });
    };
}

function updateValueOnConfiguration(name, value) {
    return (dispatch) => {
        dispatch({
            type: amazonpayConstants.UPDATE_VALUE_ON_CONFIGURATION,
            payload: { name, value },
        });
    };
}
